import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

const Post = ({ post }) => {
  return (
    <div className="post-item grid-item">
      <Link className="post-block" to={`/${post.slug}`}>
        <h3
          className="post-title"
          dangerouslySetInnerHTML={{ __html: post.title }}
        />
        <div className="post-meta">
          <time>{post.date}</time>
        </div>
      </Link>
    </div>
  );
};

Post.propTypes = {
  post: PropTypes.object,
};

export default Post;
